import React from "react";
import { Link } from "react-router-dom";
import "./community.css";

/* ==========================================================
   TOOL CARD CONFIG — Scalable for future tools
   ========================================================== */
const AI_TOOLS = [
  {
    id: "resume-critique",
    title: "📄 Resume Critique",
    desc: "Upload or paste your resume to get recruiter-level improvements instantly.",
    icon: "📄",
    link: "/community/tools/resume-critique",
  },
  {
    id: "interview-coach",
    title: "🎙 Interview Coach",
    desc: "Ask HR-style questions and receive tailored interview coaching responses.",
    icon: "🎙",
    link: "/community/tools/interview-coach",
  },
  {
    id: "career-advisor",
    title: "📊 Career Advisor",
    desc: "Get personalized career guidance, job search strategy, and growth insights.",
    icon: "📊",
    link: "/community/tools/career-advisor",
  },
  {
  id: "linkedin-generator",
  title: "🔗 LinkedIn Profile Generator",
  desc: "Create a complete recruiter-optimized LinkedIn profile.",
  icon: "🔗",
  link: "/community/tools/linkedin-generator",
},

];

/* ==========================================================
   COMPONENT
   ========================================================== */
function AITools() {
  return (
    <div className="ai-wrapper">
      <h1 className="ai-title">🤖 EmployPilot AI Tools</h1>
      <p className="ai-subtitle">
        Powerful AI tools designed to boost your career, sharpen your skills, and prepare you for real opportunities.
      </p>

      {/* TOOL GRID */}
      <div className="ai-card-container">
        {AI_TOOLS.map((tool) => (
          <Link key={tool.id} to={tool.link} className="ai-card">
            <div className="ai-card-icon">{tool.icon}</div>
            <h3 className="ai-card-title">{tool.title}</h3>
            <p className="ai-card-body">{tool.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default AITools;

